import {isEmpty} from "lodash"

import {Product} from "@irati/types"

export interface CinemaLocation {
  location: string
  products: CinemaLocationProduct[]
}

export interface CinemaLocationProduct {
  uuid: string
  label: string
  outOfStock: boolean
}

export const productsForCinema = (products: Product[], selectedLocation: string, cinemaLocations: CinemaLocation[]): Product[] => {
  const cinemaProds = products.filter((prod) => prod.data.cinemaMetadata.enabled)
  return cinemaProds.filter((prod) => {
    const location = cinemaLocations.find((l) => l.location === selectedLocation)
    if (location) {
      return !!location.products.find((p) => p.uuid === prod.uuid)
    } else {
      return false
    }
  })
}

export const getCinemaLocations = (products: Product[]): CinemaLocation[] => {
  if (isEmpty(products)) {
    return []
  }

  const locations = products.reduce((acc: any, p) => {
    const productLocations = p.data?.cinemaMetadata?.locations || []
    productLocations.forEach((l) => {
      if (!acc[l]) {
        acc[l] = [{uuid: p.uuid, label: p.name, outOfStock: false}]
      } else {
        acc[l].push({uuid: p.uuid, label: p.name, outOfStock: false})
      }
    })

    return acc
  }, {})

  const normalisedLocations = Object.keys(locations).map((key) => ({location: key, products: locations[key]})).map((item) => {
    // Make sure "Luxe" is at the end of the location.
    if (item.location.indexOf("Luxe") > -1) {
      const str = item.location.replace("Luxe", "").trim()
      return {...item, location: `${str} Luxe`}
    }
    return item
  })
  return normalisedLocations.sort((a, b) => a.location.localeCompare(b.location))
}
